import { DragOverlay } from "@dnd-kit/core";
import { motion } from "framer-motion";
import { ANIMATION_DURATIONS } from "../../utils/consts";

const grabScale = ({ transform }) => {
  const transf = {
    x: transform.x,
    y: transform.y,
    scaleX: 1.05,
    scaleY: 1.05,
  };

  return transf;
};

export default function OverlayWrapper(props) {
  const { rotateDeg, children } = props;

  return (
    <DragOverlay
      adjustScale
      dropAnimation={{
        duration: ANIMATION_DURATIONS.dragOverlayDrop_ms,
        easing: "ease-in-out",
      }}
      modifiers={[grabScale]}
      zIndex={1}
    >
      <motion.div
        initial={{ transform: "rotate(0deg)" }}
        animate={{ transform: "rotate(" + rotateDeg + "deg)" }}
        exit={{ transform: "rotate(0deg)" }} // FIXME: this wont trigger on unmount
      >
        {children}
      </motion.div>
    </DragOverlay>
  );
}
